<div class="groups">
  <mat-chip-set #groupsList
    role="list"
    [attr.aria-label]="'GROUPS' | translate">
    @if (groups$ | async; as groups) {
      @for (group of groups; track group; let i = $index) {
        @if (i < qtyGroupsToDisplay) {
          <mat-chip
            (removed)="onRemoveGroup(group)"
            [disabled]="groupsLoading || disabled"
                    [matTooltip]="
                        'REQUEST_GROUP_STATUS_TEXT'
                            | translate
                                : {
                                      groupName: group.name,
                                      managerEmail: group.managerEmail,
                                  }
                    "
          [matTooltipDisabled]="!group.requested"
          >
          @if (group.requested) {
            <fa-icon icon="paper-plane">
            </fa-icon>
          }
          <span [ngClass]="{ draft: group.requested }">{{
            group.name
          }}</span>
          @if (
            !disabled &&
            ((!group.requested && action === ACTIONS.assign) ||
            (group.requested && action === ACTIONS.request))
            ) {
            <button
              matChipRemove
              >
              <fa-icon icon="times"></fa-icon>
            </button>
          }
        </mat-chip>
      }

      @if (i === qtyGroupsToDisplay) {
        <mat-chip
                    [matTooltip]="
                        groups
                            | slice: qtyGroupsToDisplay
                            | extractPropertyPipe: 'name'
                            | join: ''
                    "
          >&#8230;</mat-chip
          >
        }
      }
    }
  </mat-chip-set>
  @if (groupsLoading) {
    <div class="loading-message">
      <mat-progress-spinner color="primary"
        matSuffix
        mode="indeterminate"
        diameter="16"
        class="loading-indicator">
      </mat-progress-spinner>
      <span>{{ 'LOADING_GROUP_OF_USER' | translate }}&hellip;</span>
    </div>
  } @else {
    @if (action === ACTIONS.assign) {
      <!-- Assign a group -->
      @if ((groups$ | async).length === 0) {
        <mat-form-field appearance="outline">
          <mat-label>{{ "ADD_GROUP" | translate }}</mat-label>
          <input
            #groupInput
            matInput
            [formControl]="groupInputForm"
            [matAutocomplete]="allGroupsList"
            />
            @if (groupInputForm.value) {
              <button
                mat-icon-button
                matSuffix
                [disabled]="groupsLoading || disabled"
                (click)="clearGroupInput()"
                >
                <fa-icon icon="times"></fa-icon>
              </button>
            }
          </mat-form-field>
        }
      } @else if (action === ACTIONS.request) {
        <!-- Request a group -->
        @if ((groups$ | async).length === 0) {
          <button
            mat-stroked-button
            color="primary"
            (click)="raiseARequestForGroup()"
            [disabled]="disabled"
            >
            <fa-icon icon="plus-circle"></fa-icon>
            {{ "REQUEST_A_GROUP" | translate }}
          </button>
        }
      } @else {
        <i style="display: none"> No action defined </i>
      }
    }
    <mat-autocomplete #allGroupsList="matAutocomplete"
      (optionSelected)="selectGroup($event)">
      @for (group of allGroups$ | async; track group) {
        <mat-option
          [value]="group">
          {{ group.name }}
        </mat-option>
      }
    </mat-autocomplete>
  </div>
